<template>
  <div class="relative inline-block text-left">
    <div class="flex items-center">
      <button
        @click="isOpen = !isOpen"
        type="button"
        class="ml-6 inline-flex items-center capitalize text-xs font-semibold text-gray-600 bg-white rounded-full leading-none px-2 py-1 lg:text-xs"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="1.5"
          stroke="currentColor"
          class="size-6 h-6 w-6 mr-2"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M9.568 3H5.25A2.25 2.25 0 0 0 3 5.25v4.318c0 .597.237 1.17.659 1.591l9.581 9.581c.699.699 1.78.872 2.607.33a18.095 18.095 0 0 0 5.223-5.223c.542-.827.369-1.908-.33-2.607L11.16 3.66A2.25 2.25 0 0 0 9.568 3Z"
          />
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M6 6h.008v.008H6V6Z"
          />
        </svg>

        Select Tag
        <svg
          class="-mr-1 h-4 w-4"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
          fill="currentColor"
          aria-hidden="true"
        >
          <path
            fill-rule="evenodd"
            d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
            clip-rule="evenodd"
          />
        </svg>
      </button>
    </div>

    <transition
      enter-active-class="transition ease-out duration-100 transform"
      enter-class="opacity-0 scale-95"
      enter-to-class="opacity-100 scale-100"
      leave-active-class="transition ease-in duration-75 transform"
      leave-class="opacity-100 scale-100"
      leave-to-class="opacity-0 scale-95"
    >
      <div
        class="origin-top-right absolute left-0 mt-2 w-56 rounded-md shadow-lg z-10"
        v-show="isOpen"
      >
        <div
          class="rounded-md bg-white shadow-xs"
          role="menu"
          aria-orientation="vertical"
          aria-labelledby="options-menu"
        >
          <div class="py-1">
            <div class="px-4">
              <input
                type="text"
                v-model="searchQuery"
                placeholder="Search tags / Add tag"
                class="block w-full px-4 py-2 text-xs leading-5 text-gray-700 bg-gray-100 border border-gray-300 rounded-md focus:outline-none focus:bg-white focus:border-indigo-500"
                @keyup.enter="addTag"
              />
            </div>
            <a
              v-for="tag in filteredTags"
              :key="tag.id"
              class="block px-4 py-2 text-xs leading-5 text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900"
              role="menuitem"
              @click="selectTag(tag.id)"
            >
              {{ tag.name }}
            </a>
          </div>
          <div class="border-t border-gray-100"></div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "TagDropdown",
  props: {
    selectedTags: {
      type: Array,
      default: () => []
    },
    conversationId: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      isOpen: false,
      searchQuery: ""
    };
  },
  computed: {
    tags() {
      return this.$store.getters["Inbox/getTags"];
    },
    filteredTags() {
      return this.tags.filter(tag =>
        tag.name.toLowerCase().includes(this.searchQuery.toLowerCase())
      );
    },
    selectedTagNames() {
      return this.selectedTags.map(tagId =>
        this.$store.getters["Inbox/getTagNameById"](tagId)
      );
    }
  },
  created() {
    window.addEventListener("click", this.handleOutsideClick);
  },
  beforeDestroy() {
    window.removeEventListener("click", this.handleOutsideClick);
  },
  methods: {
    handleOutsideClick(e) {
      if (!this.$el.contains(e.target)) {
        this.isOpen = false;
      }
    },
    selectTag(tagId) {
      this.$emit("tagsSelected", tagId);
      this.searchQuery = "";
      this.isOpen = false;
    },
    addTag() {
      const newTagName = this.searchQuery.trim();
      if (
        newTagName &&
        !this.tags.some(
          tag => tag.name.toLowerCase() === newTagName.toLowerCase()
        )
      ) {
        this.$store
          .dispatch("Inbox/createTag", {
            name: newTagName
          })
          .then(response => {
            this.selectTag(response.tag.id);
          });
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
